import { Card, CardActions, CardContent, Grid, Skeleton, Stack } from '@mui/material'

export default function BrandingOptionSkeleton() {
  return <Grid item xs={12} md={12} lg={6} xl={4}>
    <Card
      elevation={0}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        '& .MuiSkeleton-root': {
          backgroundColor: '#dedede',
        },
      }}
    >
      <CardContent
        component={Stack}
        direction="row"
        spacing={2}
        sx={{
          flexGrow: 1
        }}
      >
        <Skeleton
          variant="rounded"
          width={100}
          height={80}
          sx={{ flexShrink: 0 }}
        />
        <Stack sx={{ flexGrow: 1 }}>
          <Skeleton variant="text" width="68%" height={27} />
          <Stack direction="row" spacing={1} alignItems="center">
            <Skeleton variant="text" width="35%" height={21} />
            <Skeleton variant="rounded" width={54} height={24} />
          </Stack>
        </Stack>
      </CardContent>
      <CardActions sx={{ minHeight: 42, backgroundColor: 'rgba(0, 0, 0, 0.11)' }} />
    </Card>
  </Grid>
}
